// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3An0j","signatureButtonsRight":"ModalSign_signatureButtonsRight__1CgEa"};